import React from 'react';
import '../merchants/components/CreateMerchant.css';
import '../transaction-monitoring/TransactionMonitoring.css';
import ApiDocumentation from './ApiDocumentation';
import { ListConsolePage } from '../../components/shared/ListConsoleLayout';

const Documentation: React.FC = () => {
  return (
    <ListConsolePage
      fill={false}
      title="Documentation"
      // subtitle="Payment API integration reference — authentication, endpoints, and error codes"
    >
      <div className="apidoc-dashboard-context">
        <ApiDocumentation />
      </div>
    </ListConsolePage>
  );
};

export default Documentation;
